import { render } from "./New_MrpTab.vue?vue&type=template&id=0938afc5"
import script from "./New_MrpTab.vue?vue&type=script&lang=js"
export * from "./New_MrpTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__